/**
 * 🔴 WHICH LANGUAGE A PIECE OF DATA IS IN — design-system plan DS-4 (F375, F387).
 *
 * A customer or product name typed in Bangla sits in an English screen: in a table cell, a picker option, a badge. The
 * type layer gives Bangla a larger size and more leading only where `lang="bn"` is, so the cell that holds it must
 * say so. `langOf(text)` is `'bn'` when the text holds a Bangla LETTER or sign (the Bengali block, U+0980–U+09FF, less
 * its digits U+09E6–U+09EF and its currency and fraction signs U+09F2–U+09FB) and `undefined` otherwise — the value an
 * element's `lang` prop takes, where `undefined` sets nothing. A price, `৳1,250.00` or `৳১,২৫০.০০`, is a figure and not
 * Bangla text: an amount column stays one size (DS-4a review).
 *
 * Applied inside the table, picker and badge components (DS-6b, DS-10). A mixed string ("Rahman Store রহমান স্টোর")
 * counts as Bangla: the Bangla in it is what needs the room.
 */
const BENGALI = /[\u0980-\u09E5\u09F0\u09F1\u09FC-\u09FF]/;

export function langOf(text: string | null | undefined): 'bn' | undefined {
  return text && BENGALI.test(text) ? 'bn' : undefined;
}
